import { PureComponent, ReactNode } from 'react';
import {
    EXAMINATIONS_TO_IMAGES,
    IMPLANT_TEETH_IDS,
    MISSING_TEETH_IDS,
    SMALL_TEETH,
    UPPER_TEETH,
} from '../Utils';

interface Props {
    tooth: string;
    selectTeeth: (teeth: string) => void;
    examinations?: string[];
    isForLowerTeeth?: boolean;
    isSelectedMultiTeethArray?: boolean;
}

class ToothImage extends PureComponent<Props> {
    render(): ReactNode {
        const {
            tooth,
            selectTeeth,
            examinations,
            isForLowerTeeth,
            isSelectedMultiTeethArray,
        } = this.props;

        const isMissingTeeth = examinations?.some((i) => MISSING_TEETH_IDS.has(i));
        const isImplantTeeth = examinations?.some((i) => IMPLANT_TEETH_IDS.has(i));

        let mainImage = `/images/dental-images/type-teeth-${tooth}.webp`;
        const isChildTeeth = SMALL_TEETH.has(tooth[0]);
        const isUpperTeeth = UPPER_TEETH.has(tooth[0]);

        if (isMissingTeeth) mainImage = mainImage.replace('type', 'missing');
        else if (isImplantTeeth && !isChildTeeth) mainImage = mainImage.replace('type', 'implant');
        else mainImage = mainImage.replace('type-', '');

        const visualExaminations = examinations
            ?.map((i) => EXAMINATIONS_TO_IMAGES[i])
            ?.filter(Boolean);

        return (
            <div
                className="relative max-w-64 max-h-120 cursor-pointer"
                onClick={() => selectTeeth(tooth)}
            >
                <img
                    src={mainImage}
                    alt={tooth}
                    loading="lazy"
                    className="w-full h-full cursor-pointer"
                />
                {visualExaminations?.map((i) => {
                    const subImage = `/images/dental-images/${isUpperTeeth ? 'u-' : 'l-'}${i}.webp`;
                    return (
                        <img
                            src={subImage}
                            alt={subImage}
                            loading="lazy"
                            className="absolute inset-0"
                        />
                    );
                })}

                {isSelectedMultiTeethArray && (
                    <p
                        className={`absolute left-0 right-0 text-center ${
                            isForLowerTeeth ? 'top-24' : 'bottom-24'
                        } font-700 text-13`}
                    >
                        {tooth}
                    </p>
                )}
            </div>
        );
    }
}

export default ToothImage;
